export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s er ikke valgt';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s må ikke være tom';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s er et obligatorisk felt';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s er ikke udfyldt korrekt';
                break;

            case 'opt-in':
                translation = 'Afkryds venligst dette felt for at fortsætte';
                break;

            default:
                translation = 'Dette felt er ikke udfyldt korrekt';
                break;
        }

        return translation;
    }
}
